<template>
    <div class="bg-white footer border-top">
        <div class="d-flex align-items-center h-100">
            <div class="text-muted mx-auto">© {{ year }} The Owl Centre</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import moment from 'moment';

    export default Vue.extend({
        data() {
            return {
                year: moment().format('YYYY')
            };
        }
    });
</script>
